import { betTypeExacta, BetTypeName, betTypeTrifecta, betTypeWin } from "interfaces/bet-type-name";

export const defaultBetTypesOrder = [betTypeWin, betTypeExacta, betTypeTrifecta];

export const sortBetTypes = (poolTypes: BetTypeName[]) => defaultBetTypesOrder
  .filter((type) => poolTypes.includes(type));